import BlogPostCard from './blog-post-card';

export default BlogPostCard;
